import './Header.css';

function Header() {
    return(
        <div className="header">
            <i class="fa-solid fa-globe"></i>
            FUND MANAGER
        </div>
    )
        
}

export default Header;